// core
import { ARTICLE_KEY, ROUTE_URL, VISITOR_PRIVILEGES } from './config';
import { slots as basicSlots, Slot } from 'basic/slots';
import { Banners } from '_core/views/Banners';
import { byVisitorPrivileges } from '_core/utils/visitorInfo';
import { BriefStats } from '_core/views/BriefStats';
import { Readings } from '_core/views/Readings';
import { PopupMessages } from 'basic/views/PopupMessages';

export * from 'basic/slots'

export const slots = {
  ...basicSlots,

  dashboard: [
    Slot(ARTICLE_KEY.DASHBOARD_SLOT),
    Banners,
    byVisitorPrivileges(BriefStats, '(' + VISITOR_PRIVILEGES.PARTNER + ') or (' + VISITOR_PRIVILEGES.ADMIN + ')'),
    PopupMessages,
    Readings,
  ],

  about: [Slot(ARTICLE_KEY.ABOUT_SLOT)],
}
